import { render, staticRenderFns } from "./PriceChangesTable.vue?vue&type=template&id=72286a2c&scoped=true&"
import script from "./PriceChangesTable.vue?vue&type=script&lang=js&"
export * from "./PriceChangesTable.vue?vue&type=script&lang=js&"
import style0 from "./PriceChangesTable.vue?vue&type=style&index=0&id=72286a2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72286a2c",
  null
  
)

export default component.exports